// this file gets replaced with the real value during the build
const Version = '6.8.3';

export { Version as default };
